import { ClerkAuthWrapper } from "./ClerkAuthWrapper";

export function LoginForm() {
  return <ClerkAuthWrapper mode="signin" />;
}
